<template>
  <div class="login-container">
    <b-row>
      <b-col cols="6" class="s">
        <img :src="loginImageSource" class="fluid" />
      </b-col>
      <b-col cols="6" class="login-wrapper">
        <img :src="backgroundImage" class="fluid img-wrapper" />
        <Login
          :firstTitle="$t('login.newPassword')"
          :secondTitle="$t('login.repeatNewPassword')"
          :buttonText="$t('login.enter')"
          firstInputType="password"
          secondInputType="password"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Login from './login'
import IdpDataProvider from '../../services/idp'
export default {
  components: {
    Login,
  },
  data() {
    return {
      loginImageSource: null,
      backgroundImage: null,
    }
  },
  mounted() {
    IdpDataProvider.getPagePermisions({
      path: '/login',
    }).then(res => {
      this.loginImageSource = res.data.data.config.image
      this.backgroundImage = res.data.data.config.backgroundImage
      
    })
  },
}
</script>

<style>
@import '../../design/custom/pages/_login_pages.scss';
</style>
